export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const API_ROUTES = {
  CLIENTES: {
    BASE: '/api/clientes',
    DETAILS: (id: string) => `/api/clientes/${id}`,
    VERIFICAR_CPF: '/api/clientes/verificar-cpf',
    DELETE_MULTIPLE: '/api/clientes/batch/delete',
    DOCUMENTOS: {
      LISTAR: (id: string) => `/api/clientes/${id}/documentos`,
      UPLOAD: (id: string) => `/api/clientes/${id}/upload-documento`,
      EXCLUIR: (id: string, documentoId: string) => `/api/clientes/${id}/documentos/${documentoId}`,
    },
  },
  AUTH: {
    LOGIN: '/api/auth/login',
    REFRESH_TOKEN: '/api/auth/refresh-token',
    REQUEST_PASSWORD_RESET: '/api/auth/request-password-reset',
    RESET_PASSWORD: '/api/auth/reset-password',
    ME: '/api/auth/me',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
  },
  DASHBOARD: {
    SUPER_ADMIN: '/api/dashboard/super-admin',
    ASSOCIADO: '/api/dashboard/administrador-geral',
    SECRETARIA: '/api/dashboard/secretaria',
    SUPERVISOR: '/api/dashboard/supervisor',
    RELACIONADOR: '/api/dashboard/relacionador',
    LIDER_VENDAS: '/api/dashboard/lider-vendas',
    // CLIENTE removido - funcionalidade não implementada
    // CLIENTE: '/api/dashboard/cliente',
    STATS: '/api/dashboard/stats',
    CONTRACTS: '/api/dashboard/contracts',
    USERS: '/api/dashboard/users',
    ACTIVITIES: '/api/dashboard/activities',
    EXPORT: '/api/dashboard/export',
  },
  GRUPOS: {
    BASE: '/api/grupos',
    DETAILS: (id: string) => `/api/grupos/${id}`,
    BENS: (id: string) => `/api/grupos/${id}/bens`,
    REGRAS_LANCE: (id: string) => `/api/grupos/${id}/regras-lance`,
    TAXAS: (id: string) => `/api/grupos/${id}/taxas`,
  },
  COTAS: {
    BASE: '/api/cotas',
    DETAILS: (id: string) => `/api/cotas/${id}`,
    BY_GRUPO: (grupoId: number) => `/api/cotas/grupo/${grupoId}`,
    RELATIONS: (id: string) => `/api/cotas/${id}/relations`,
    OCUPAR: (id: string) => `/api/cotas/${id}/ocupar`,
    LIBERAR: (id: string) => `/api/cotas/${id}/liberar`,
    CONTEMPLAR: (id: string) => `/api/cotas/${id}/contemplar`,
    QUITAR: (id: string) => `/api/cotas/${id}/quitar`,
  },
  CONTRATOS: {
    BASE: '/api/contratos',
    DETAILS: (id: string) => `/api/contratos/${id}`,
    HISTORICO: (id: string) => `/api/contratos/${id}/historico`,
    DOCUMENTOS: (id: string) => `/api/contratos/${id}/documentos`,
    PAGAMENTOS: (id: string) => `/api/contratos/${id}/pagamentos`,
    UPLOAD_DOCUMENTO: (id: string) => `/api/contratos/${id}/upload-documento`,
    EXCLUIR_DOCUMENTO: (id: string, documentoId: string) => `/api/contratos/${id}/documentos/${documentoId}`,
    ASSINATURA: (id: string) => `/api/contratos/${id}/assinatura`,
  },
  TEAMS: '/api/teams',
  TEAM_INVITATIONS: '/api/team-invitations',
  AVAILABLE_USERS: '/api/available-users',
  RELACIONADORES: '/api/relacionadores',
  CONSULTORES: '/api/consultores',
  CONTRATO_CHECAGENS: {
    BASE: '/api/contrato-checagens',
    DETAILS: (id: string) => `/api/contrato-checagens/${id}`,
    BY_CONTRATO: (contratoId: string) => `/api/contrato-checagens/contrato/${contratoId}`,
    PENDENTES: '/api/contrato-checagens/pendentes',
    EM_ANALISE: '/api/contrato-checagens/em-analise',
    FINALIZADAS: '/api/contrato-checagens/finalizadas',
    INICIAR: (id: string) => `/api/contrato-checagens/${id}/iniciar`,
    FINALIZAR: (id: string) => `/api/contrato-checagens/${id}/finalizar`,
  },
  COMISSOES: {
    BASE: '/api/comissoes',
    DETAILS: (id: string) => `/api/comissoes/${id}`,
    EXPORT: '/api/comissoes/export',
    RELATORIO_MENSAL: '/api/comissoes/relatorio-mensal',
    APROVAR: (id: string) => `/api/comissoes/${id}/aprovar`,
    PAGAR: (id: string) => `/api/comissoes/${id}/pagar`,
  },
  SUPERADMIN: {
    USERS: {
      BASE: '/api/superadmin/users',
      DETAILS: (id: string) => `/api/superadmin/users/${id}`,
    },
    STATS: '/api/superadmin/stats',
    TENANTS: {
      BASE: '/api/superadmin/tenants',
      DETAILS: (id: string) => `/api/superadmin/tenants/${id}`,
    },
    SETTINGS: {
      BASE: '/api/superadmin/settings',
      DETAILS: (id: string) => `/api/superadmin/settings/${id}`,
    },
  },
} 